/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';

    const constants = require('@utils/_constants');

    angular
        .module('enervee')
        .directive('signupModal', signupModalDirective);

    function signupModalDirective() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                '$state',
                'AccountAuthService',
                'AccountSettingsService',
                'AnalyticsService',
                'GdprService',
                'IndexService',
                'SignupService',
                'UtilService',
                function signupModalController (
                    $scope,
                    $state,
                    AccountAuthService,
                    AccountSettingsService,
                    AnalyticsService,
                    GdprService,
                    IndexService,
                    SignupService,
                    UtilService
                ) {
                    $scope.passwordMinLength = UtilService.getSetting('passwordMinLength');
                    $scope.signupModalSubheader = IndexService.getSignupModalSubheader;
                    $scope.signupModalHeader = IndexService.getSignupModalHeader;
                    $scope.signupModalFilters = IndexService.getSignupModalFilters;
                    $scope.resetFormField = IndexService.resetFormField;
                    $scope.existingUserEmail = null;
                    $scope.showGdprLayout = false;
                    $scope.passwordModalBusy = false;
                    $scope.signUpAgreementHTML = UtilService.getSiteSetting('signup_agreement_html');
                    $scope.validateFormField = IndexService.validateFormField;
                    $scope.passwordMinLengthContext = {
                        min_length: $scope.passwordMinLength
                    };
                    $scope.user = {
                        email: "",
                    }
                    $scope.emailIsReadonly = false;

                    SignupService.signUpModalOpenedCallBack = function (trigger) {
                        var gdprTextKeyPrefix = '';
                        $scope.passwordModalBusy = false;

                        if (trigger === constants.EVENT_TYPE_LIKE) {
                            $scope.dataTrigger = "Favorited Product";
                            gdprTextKeyPrefix = 'favorite_';
                        } else if (trigger === constants.SAVED_SEARCH_TYPE_LIKE) {
                            $scope.dataTrigger = "Saved Search";
                            gdprTextKeyPrefix = 'saved_search_';
                        } else if (trigger === constants.EVENT_REBATE_CLAIM_OPT_IN) {
                            $scope.dataTrigger = "Rebate Claim Opt In";
                            gdprTextKeyPrefix = 'rebate_opt_in_';
                        } else if (trigger === constants.EVENT_SOLAR_SIGN_UP) {
                            $scope.dataTrigger = "Solar Lead";
                        } else {
                            $scope.dataTrigger = "Sign In";
                        }

                        GdprService.getCmsText(gdprTextKeyPrefix).then(function (gdprText) {
                            $scope.showGdprLayout = !!gdprText.main;
                            $scope.gdprText = gdprText.main;
                            $scope.gdprCookieText = gdprText.cookie;
                        });

                        $scope.emailIsReadonly = !!SignupService.getRequiredEmail();
                        if ($scope.emailIsReadonly) {
                            $scope.user.email = SignupService.getRequiredEmail();
                        }
                    };

                    /**
                    * If on product detail page get product data
                    */
                    var getProductInfo = function() {
                        // add product for meta event
                        if ($state.$current.name === "product.base") {
                            return $state.$current.parent.data.productDetailData;
                        }
                        return null;
                    };

                    /**
                    * Submits the sign up email form.
                    *
                    * @param user
                    * @param currentModal
                    */
                    $scope.submitEmailModalForm = function(user, currentModal) {
                        const product = getProductInfo();

                        SignupService.doesUserEmailExist(user.email).then(function() {
                            $scope.newUserEmail = user;
                            var _user = SignupService.getDoesUserExist();

                            // Fully registered user exists
                            if (_user.exists === true && _user.password_set === true) {
                                // Load the enter password modal
                                IndexService.switchModal(currentModal, '#modal-enter-password');
                                SignupService.updateLoginCredentials(user.email);
                                SignupService.signInPasswordModalOpenedCallBack($scope.dataTrigger);

                                // Partial registered user exists, password needs to be set
                            } else if ( _user.exists === true && _user.password_set === false) {
                                // Load the `send reset link?` modal
                                $scope.existingUserEmail = user.email;
                                $scope.nextUrl = SignupService.getNextUrl();
                                IndexService.switchModal(currentModal, '#modal-reset-password-link');
                                AnalyticsService.reportEvent('Signed In', {
                                    email: user.email,
                                    type: $scope.dataTrigger,
                                    location: 'modal',
                                    status: 'half user'
                                }, product);
                                // New user
                            } else {
                                $scope.existingUserEmail = user.email;
                                SignupService.updateLoginCredentials(user.email);
                                IndexService.switchModal(currentModal, '#modal-create-password');
                            }
                        });
                    };

                    var resetUserCompleted = function() {
                        $scope.passwordModalBusy = false;
                    };

                    AccountAuthService.onAuthChangeAllPages(resetUserCompleted);

                    /**
                    * Sets the user email from other application feature directives.
                    */
                    $scope.$on('login-credentials-set', function(obj, email) {
                        $scope.userEmail = email;
                    });

                    /**
                    * Submits the password for a new user.
                    * @param password
                    * @param currentModal closes the current modal if successful
                    */
                    $scope.submitCreatePasswordModalForm = function(password, currentModal) {
                        $scope.passwordModalBusy = true;
                        const product = getProductInfo();

                        SignupService.saveUserPassword(
                            $scope.userEmail, password.newPassword, password.confirmPassword
                        ).then(function () {
                            var passwordResponse  = SignupService.wasPasswordSaved();

                            if (passwordResponse.created === true) {
                                // success: password set
                                AnalyticsService.trackUser({
                                    full_user: true
                                }, product);
                                AnalyticsService.reportEvent('Signed Up', {
                                    email: $scope.userEmail,
                                    type: $scope.dataTrigger,
                                    location: 'modal',
                                    status: 'full user'
                                }, product);

                                // clear submitted password stored in model
                                password.newPassword = null;
                                password.confirmPassword = null;

                                IndexService.closeModal(currentModal);
                            } else {
                                // error: failed the server password match validation
                                $scope.createPasswordForm.newPassword.$error.message = passwordResponse.error.toString();
                                $scope.createPasswordForm.confirmPassword.$error.message = passwordResponse.error.toString();
                            }
                        });
                    };

                    /**
                    * Creates a user with no password. User gets logged in and an email sent
                    * to create their password.
                    * If a user visits the page again we prompt them with create a password.
                    */
                    $scope.registerUser = function () {
                        $scope.passwordModalBusy = true;
                        const product = getProductInfo();

                        AccountAuthService.registerUser($scope.userEmail).then(function () {
                            let user = AccountAuthService.wasUserRegistered();

                            if (user.registered === true) {
                                AccountAuthService.setIsAuthenticated(true);
                                AnalyticsService.trackUser({
                                    email: user.email,
                                    created_at: new Date(),
                                    signup_source: $scope.dataTrigger,
                                    user_utility: UtilService.getSetting('utilityId'),
                                    verified_user: false,
                                    full_user: false
                                }, product);

                                AnalyticsService.reportEvent('Signed Up', {
                                    email: user.email,
                                    type: $scope.dataTrigger,
                                    location: 'modal',
                                    status: 'half user'
                                }, product);
                                
                                // Fetch the user info to log the user in
                                let force = true;
                                AccountSettingsService.getAccountInfo(force);
                            } else {
                                let alerts = [{
                                    type: 'error',
                                    message: 'User registration failed. Please try again later.'
                                }];

                                IndexService.setHeaderAlerts(alerts);
                            }
                            IndexService.closeModal('#modal-create-password');
                        });
                    };

                    /**
                     * Fired when the user clicks "do this later" create an account
                     * with no password.
                     */
                    $scope.onClickDoThisLater = () => {
                        $scope.registerUser();
                    }
                }
            ],
            template: require('@app/shared/modals/signup/signUp.html'),
        };
    }
})(angular);
